<template>
  <circle :cx="cx" :cy="cy" :r="r" :fill="fill" :opacity="opacity" />
</template>

<script>
export default {
  name: 'dot',
  props: ['cx', 'cy', 'r', 'fill', 'opacity']
}
</script>


// WEBPACK FOOTER //
// dot.vue?1eee1ae4